var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Datepicker } from '@datepicker-react/styled';
import { ThemeProvider } from 'styled-components';
import DateCell from './date-cell';
import { defaultTabTheme, defaultMobileTheme, defaultPhrases, today, weekdayLabels } from './datepicker-defaults';
import { DatepickerWrapper } from './datepicker-styles';
import Header from './header';
var DatepickerContainer = function (_a) {
    var translate = _a.translate, top = _a.top, left = _a.left, zIndex = _a.zIndex, daysString = _a.daysString, nightsString = _a.nightsString, startDate = _a.startDate, endDate = _a.endDate, focusedInput = _a.focusedInput, onDatesChange = _a.onDatesChange, handleMouseEnter = _a.handleMouseEnter, handleMouseLeave = _a.handleMouseLeave, isMobile = _a.isMobile, restProps = __rest(_a, ["translate", "top", "left", "zIndex", "daysString", "nightsString", "startDate", "endDate", "focusedInput", "onDatesChange", "handleMouseEnter", "handleMouseLeave", "isMobile"]);
    return (React.createElement(ThemeProvider, { theme: isMobile ? defaultMobileTheme : defaultTabTheme },
        React.createElement(DatepickerWrapper, { translateX: translate, top: top, left: left, zIndex: zIndex },
            React.createElement(Datepicker, __assign({ onDatesChange: onDatesChange, startDate: startDate, endDate: endDate, focusedInput: focusedInput, displayFormat: 'DD/MM/YYYY', phrases: defaultPhrases, showSelectedDates: false, showClose: isMobile, vertical: isMobile, numberOfMonths: isMobile ? 1 : 2, minBookingDate: today, weekdayLabelFormat: function (date) { return weekdayLabels[date.getDay()]; }, onDayRender: function (date) { return (React.createElement(DateCell, { handleMouseEnter: handleMouseEnter, date: date, state: { startDate: startDate, endDate: endDate, focusedInput: focusedInput }, handleMouseLeave: handleMouseLeave })); } }, restProps)),
            React.createElement(Header, { startDate: startDate, endDate: endDate, focusedInput: focusedInput, daysString: daysString, nightsString: nightsString }))));
};
export default DatepickerContainer;
